import { render } from "./App.vue?vue&type=template&id=7bfd68de"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7bfd68de&lang=css"

import exportComponent from "/var/www/html/modulo_facturacion_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__